import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"

export const FontWeightV1 = z.union([
  z.literal("100"),
  z.literal("200"),
  z.literal("300"),
  z.literal("400"),
  z.literal("500"),
  z.literal("600"),
  z.literal("700"),
  z.literal("800"),
  z.literal("900"),
  z.literal("lighter"),
  z.literal("normal"),
  z.literal("bold"),
  z.literal("bolder"),
])

export type TFontWeight = z.infer<typeof FontWeightV1>

// Version 1 ---------------------
export const TitleSettingsV1 = z.object({
  type: z.union([
    z.literal("h1"),
    z.literal("h2"),
    z.literal("h3"),
    z.literal("h4"),
    z.literal("h5"),
    z.literal("h6"),
  ]),
  text: z.string(),
  shadow: z.union([z.literal(true), z.literal(false)]),
  weight: FontWeightV1,
  badge: z.union([z.literal(true), z.literal(false)]),
  style: z.string(),
})

export type TTitleSettingsV1 = z.infer<typeof TitleSettingsV1>

export const TitleElementV1 = z.object({
  id: z.string(),
  name: z.literal("title"),
  settings: TitleSettingsV1,
  container: ContainerOptionsV1,
})

export type TTitleElementV1 = z.infer<typeof TitleElementV1>

// Latest ---------------------
export const TitleSettings = TitleSettingsV1
export type TTitleSettings = TTitleSettingsV1
export const TitleElement = TitleElementV1
export type TTitleElement = TTitleElementV1
